//#region import libraries
import React, { useState, useEffect } from 'react';
//bootstrap
import { Container, Row, Col, Button, Form, Spinner, Modal } from 'react-bootstrap';
//custom components
import { Title, NewScreen } from "_atoms";
//redux
import { useSelector, useDispatch } from 'react-redux';
import { selectFirebaseUser, selectUserDb } from '_redux/slices/main-screen/user';
import { selectFeedbackStatus, postFeedback, reset } from '_redux/slices/profile/feedback';
import { setScreen } from '_redux/slices/main-screen/render-screen';
//styles
import { Colors } from '_styles';
//components
import { GoMail } from "react-icons/go";
import validator from 'validator';
import Select from 'react-select'
import { toast } from 'react-toastify';
//#endregion

const Contact = () => {

    //#region redux 
    const dispatch = useDispatch();
    const firebaseUser = useSelector(selectFirebaseUser)
    const userDb = useSelector(selectUserDb)
    const feedbackStatus = useSelector(selectFeedbackStatus)
    //#endregion

    //#region local states
    const [firstName, setFirstName] = useState('');
    const [secondName, setSecondName] = useState('');
    const [email, setEmail] = useState("");
    const [subject, setSubject] = useState("");
    const [message, setMessage] = useState("");
    const [airport, setAirport] = useState("");
    const [submitted, setSubmitted] = useState(false);
    const [successModal, setSuccessModal] = useState(false);

    // errors 
    const [errors, setErrors] = useState({});
    //#endregion

    const notify = (text) => toast(text);
    //#region functions
    // handle submission
    const handleFormSubmission = () => {
        let errors = {};
        let isValidEmail = validator.isEmail(email);

        if (firstName.length == 0) {
            notify("Invalid first name")
            errors.firstName = "name required";
        }
        if (secondName.length == 0) {
            notify("Invalid second name")
            errors.secondName = "second name required";
        }
        if (email.length == 0) {
            notify("Please enter your email")
            errors.email = "email required";
        }
        if (subject.length == 0) {
            notify("Invalid subject")
            errors.subject = "Valid subject required";
        }
        if (!isValidEmail) {
            notify("Please enter a valid email")
            errors.email = "Valid email required"
        }
        if (message.length == 0) {
            notify("Please enter a valid message")
            errors.message = "Valid message required"
        }
        if (firstName.length != 0 && secondName.length != 0 && isValidEmail && subject.length != 0 && message.length != 0) {
            // submit contact
            setErrors({})
            notify('successful entry')
            setSubmitted(true)
            console.log(message, "Message,,,")
            // send review           
            dispatch(postFeedback({
                userId: firebaseUser.uid + ' - Portal User',
                name: firstName + ' ' + secondName + ' - ' + airport,
                subject: subject.label,
                message: message,
                email: email
            }))

        }
        else {
            // return errors
            setErrors(errors)
        }
        return;
    }
    // handle ext
    const exit = () => {
        setSuccessModal(false)
        dispatch(setScreen('account'))
    }
    //#endregion
    //#region useEffect
    // load in user values
    useEffect(() => {
        if (firebaseUser) {
            setEmail(firebaseUser.email)
            const name = firebaseUser.displayName.split(' ');
            setFirstName(name[0]);
            setSecondName(name[1]);
        }
        if (userDb) {
            setAirport(userDb.details.authority)
        }
        dispatch(reset())   // reset feedback slice
    }, []);


    useEffect(() => {
        if (feedbackStatus == 'succeeded' && submitted) {
            setSuccessModal(true)
            setSubject("");
            setMessage("")
        }
    }, [feedbackStatus]);

    //#endregion

    // subject selector 
    const subjects = [{ "value": "Question", "label": "Question" }, { "value": "Suggestion", "label": "Suggestion" }, { "value": "Complaint", "label": "Complaint" }];

    return (
        <NewScreen>
            <div>
                <Row>

                    {/* Title */}
                    <Title name="Contact" />

                    {/* Backbutton */}
                    {/* <Backbutton page={'account'} /> */}

                    <Container style={{ marginLeft: 200 }}>

                        {/* Icon */}
                        <div>
                            <GoMail size={64} color='#307FE2' />
                        </div>

                        {/* Subtitle */}
                        <p className="mt-3" style={{ fontSize: 26, fontWeight: 'bold' }}>Send us a Message</p>

                        <div className="mt-3" style={{}}>
                            <p style={{ fontSize: 18, fontWeight: '600', opacity: 0.6 }}>We'll review your message and respond by email.</p>
                        </div>
                    </Container>

                    <Container style={{ justifyContent: 'center', width: '50%', marginLeft: 200 }}>
                        <Form>

                            {/* Name */}
                            <Form.Group>
                                <Row>
                                    {/* First */}
                                    <Col>
                                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>First Name</Form.Label>
                                        <Form.Control value={firstName} onChange={(e) => setFirstName(e.target.value)} autoComplete='off' type="name" placeholder="Enter first name" />
                                        {errors.firstName && (<p className="text-danger">{errors.firstName}</p>)}
                                    </Col>

                                    {/* Second */}
                                    <Col>
                                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>Second Name</Form.Label>
                                        <Form.Control value={secondName} onChange={(e) => setSecondName(e.target.value)} autoComplete='off' type="name" placeholder="Enter second name" />
                                        {errors.secondName && (<p className="text-danger">{errors.secondName}</p>)}
                                    </Col>
                                </Row>
                            </Form.Group>

                            {/* Email */}
                            <Form.Group className='mt-3'>
                                <Row>
                                    <Col>
                                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>Email</Form.Label>
                                        <Form.Control value={email} onChange={(e) => setEmail(e.target.value)} type="name" placeholder="Enter email" />
                                        {errors.email && (<p className="text-danger">{errors.email}</p>)}
                                    </Col>
                                </Row>
                            </Form.Group>

                            {/* Airport */}
                            <Form.Group className='mt-3'>
                                <Row>
                                    <Col>
                                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>{userDb.details.type === "AIRLINE" ? "Airline" : "Airport"}</Form.Label>
                                        <Form.Control value={airport} disabled={true} onChange={(e) => setEmail(e.target.value)} type="name" placeholder="Airport" />
                                        {errors.airport && (<p className="text-danger">{errors.airport}</p>)}
                                    </Col>
                                </Row>
                            </Form.Group>

                            {/* Subject */}
                            <Form.Group className='mt-3'>
                                <Row>
                                    <Col>
                                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>Subject</Form.Label>
                                        <Select options={subjects} value={subject} onChange={(selection) => { setSubject(selection) }} />
                                        {errors.subject && (<p className="text-danger">{errors.subject}</p>)}
                                    </Col>
                                </Row>
                            </Form.Group>

                            {/* Message */}
                            <Form.Group className='mt-3'>
                                <Row>
                                    <Col>
                                        <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>Contact Message</Form.Label>
                                        <Form.Control as={"textarea"} value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Type your message here..." style={{ height: 150 }} />
                                        {errors.message && (<p className="text-danger">{errors.message}</p>)}
                                    </Col>
                                </Row>
                            </Form.Group>

                            {/* Cancel Button 
                            {
                                feedbackStatus == 'succeeded' && submitted == true ?
                                    null
                                :
                                <Button className="mt-5" variant="outline-danger" loading={true} style={{width:175}} onClick={handleFormSubmission}>
                                    {
                                        feedbackStatus == 'loading' ?                                             
                                        <>
                                            <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            />
                                        </>
                                        :
                                        'Cancel'
                                    }
                                </Button>
                            }
                            */}

                            {/* Submit Button */}
                            <Button className="mt-5" variant={feedbackStatus == 'succeeded' && submitted == true ? 'outline-success' : "outline-primary"} disabled={feedbackStatus == 'succeeded' && submitted == true ? true : false} loading={true} style={{ width: 175, marginLeft: 10 }} onClick={handleFormSubmission}>
                                {
                                    feedbackStatus == 'loading' ?
                                        <>
                                            <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            />
                                        </>
                                        :
                                        feedbackStatus == 'succeeded' && submitted == true ?
                                            'Successful'
                                            :
                                            'Submit'
                                }
                            </Button>
                        </Form>
                    </Container>

                    <Col>
                    </Col>

                </Row>

                {/* Success Modal */}
                <Modal show={successModal} onHide={exit}>
                    <Modal.Header closeButton>
                        <Modal.Title>Feedback Submitted</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>Your feedback has sucessfully been submitted to our team. We will take a look and respond via email as quickly as we can. Thank you for your patience.</Modal.Body>

                    <Modal.Footer>
                        <Button variant="outline-success" onClick={exit}>
                            Done
                        </Button>
                    </Modal.Footer>
                </Modal>

            </div>
        </NewScreen>
    )
}

export default Contact;